import { OkDialog } from '@/components/molecules/dialogs/OkDialog';
import { useTranslation } from '@/core/hooks';
import { useAppStore } from '@/core/stores/appStore';
import React from 'react';

/**
 * Global error handler component for 401/403 unauthorized errors and network errors
 * Shows a dialog when unauthorized errors or network errors occur
 */
export function GlobalErrorHandler() {
    const { t } = useTranslation();
    const unauthorizedError = useAppStore((state) => state.unauthorizedError.message);
    const setUnauthorizedError = useAppStore((state) => state.setUnauthorizedError);

    const handleDialogClose = () => {
        setUnauthorizedError(null);
    };

    // Get error message - check if it's a translation key or plain text
    const getErrorMessage = () => {
        if (!unauthorizedError) {
            return t('auth.sessionExpired' as any);
        }

        // Check if it's a translation key (contains dot notation)
        if (unauthorizedError.includes('.')) {
            try {
                // Try to translate it (e.g., 'errors.networkError', 'auth.sessionExpired')
                const parts = unauthorizedError.split('.');
                if (parts.length === 2) {
                    const [namespace, key] = parts;
                    // Use type assertion to allow any translation key
                    const translationKey = `${namespace}.${key}` as any;
                    const translated = t(translationKey);
                    // If translation returns the key itself, it means it wasn't found, use original
                    return translated !== translationKey ? translated : unauthorizedError;
                }
            } catch {
                // If translation fails, return original message
            }
        }

        return unauthorizedError;
    };

    return (
        <OkDialog
            visible={!!unauthorizedError}
            message={getErrorMessage()}
            okText={t('common.close' as any)}
            onOk={handleDialogClose}
        />
    );
}

